import React from "react";
import { Link } from "react-router-dom";
import "./ApplicationSuccess.css";

const ApplicationSuccess = () => {
  return (
    <div className="application-success">
      <h1>Application Submitted Successfully!</h1>
      <p>Thank you for applying. We will review your application and get back to you soon.</p>
      <Link to="/careers">Back to Jobs</Link>
    </div>
  );
};

export default ApplicationSuccess;